export default "__VITE_ASSET__CbQ2nOPM__"